import { render, staticRenderFns } from "./RFQPartsPanel.vue?vue&type=template&id=6bbdd83c&"
import script from "./RFQPartsPanel.vue?vue&type=script&lang=js&"
export * from "./RFQPartsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports